<div #profileWindow id="profile_window" class="profile-window" [class.visible]="visible">
  <!-- Title Bar -->
  <div class="profile-titlebar" #titlebar>
    <span class="profile-title">
      <span>Profile</span>
    </span>
    <span class="profile-info">
      <span>Points: {{ numPoints() | number }}</span>
    </span>
    <button
      type="button"
      class="close-button"
      (click)="onClose()"
      aria-label="Close profile window"
    >
      <img src="images/close.svg" alt="Close" class="button-icon" />
    </button>
  </div>

  <!-- Main Content -->
  <div class="profile-content">
    <div class="profile-main">
      <!-- Controls Section -->
      <div class="profile-controls-section">
        <div class="control-group">
          <label class="control-label">Rotate Amount (°)</label>
          <input
            type="number"
            class="control-input"
            min="1"
            max="90"
            [value]="rotateAmount()"
            (input)="onRotateAmountChange(+$any($event.target).value)"
            placeholder="10"
          />
        </div>

        <div class="control-group">
          <label class="control-label">Profile Controls</label>
          <div class="button-group">
            <app-button type="button" variant="default" (click)="onRotateClockwise()">
              ↻ Rotate CW
            </app-button>
            <app-button type="button" variant="default" (click)="onRotateCounterClockwise()">
              ↺ Rotate CCW
            </app-button>
            <app-button type="button" variant="default" (click)="onMoveForward()">
              ↑ Move Forward
            </app-button>
            <app-button type="button" variant="default" (click)="onMoveBackward()">
              ↓ Move Backward
            </app-button>
          </div>
        </div>

        <div class="control-group">
          <label class="control-label">Export</label>
          <div class="button-group">
            <app-button type="button" variant="default" (click)="onDownloadDXF2D()">
              DXF 2D
            </app-button>
            <app-button type="button" variant="default" (click)="onDownloadDXF3D()">
              DXF 3D
            </app-button>
            <app-button type="button" variant="default" (click)="onDownloadCSV()">CSV</app-button>
            <app-button type="button" variant="default" (click)="onDownloadLAS()">LAS</app-button>
          </div>
        </div>
      </div>

      <!-- Profile Drawing Container -->
      <div class="profile-draw-container">
        <!-- SVG Overlay for Axes -->
        <svg #profileSVG class="profile-svg"></svg>

        <!-- WebGL Canvas Container -->
        <div #profileCanvasContainer class="profile-canvas-container"></div>

        <!-- Selection Properties -->
        <div
          class="profile-selection-properties"
          *ngIf="showSelectionProperties() && selectedPosition() && selectedRgb()"
        >
          <div>
            Position: {{ selectedPosition()!.x | number: '1.2-2' }},
            {{ selectedPosition()!.y | number: '1.2-2' }}, {{ selectedPosition()!.z | number: '1.2-2' }}
          </div>
          <div>RGB: {{ selectedRgb()![0] }} {{ selectedRgb()![1] }} {{ selectedRgb()![2] }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
